import { h } from 'preact';
import { formatMoney } from '../utils/helpers';

const PriceRange = ({ pricesArr, comparePricesArr }) => (
  <div class="flex">
    {(Math.min(...pricesArr) !== Math.max(...pricesArr) && (
      <div className="font-m-12 tablet:font-m-14">
        {formatMoney({ amount: Math.min(...pricesArr) * 100 }, true)}
        <span class="px-1">-</span>
        {formatMoney({ amount: Math.max(...pricesArr) * 100 }, true)}
      </div>
    )) || (
      <div className="font-m-12 tablet:font-m-14">
        {formatMoney({ amount: Math.min(...pricesArr) * 100 }, true)}
      </div>
    )}

    {/* Show strikethrough price only if pricesArr and comparePricesArray
        both have the same prices */}
    {!!comparePricesArr.length
      && Math.min(...comparePricesArr) === Math.max(...comparePricesArr)
      && Math.min(...pricesArr) === Math.max(...pricesArr) && (
      <del className="font-m-12 pl-1 text-secondary-1 tablet:font-m-14">
        {formatMoney({ amount: Math.min(...comparePricesArr) * 100 }, true)}
      </del>
    )}
  </div>
);

export default PriceRange;
